export default __webpack_public_path__ + "static/media/profilePic-4.5c08b598.jpg";